const chatbot = document.querySelector("#chatbot");

const initScrollTop = () => {
  const scrollTopBtn = document.querySelector(".scrollTopBtn");
  if (!scrollTopBtn) {
    return;
  }

  const handleScroll = () => {
    if (window.scrollY > 500) {
      scrollTopBtn.classList.add("scrollTopBtn--show");
    } else {
      scrollTopBtn.classList.remove("scrollTopBtn--show");
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (!chatbot) {
    scrollTopBtn.classList.add("no-chatbot");
  }

  document.addEventListener("scroll", handleScroll);
  handleScroll();

  scrollTopBtn.addEventListener("click", (event) => {
    event.preventDefault();
    scrollToTop();
  });
};

if (window.innerWidth > 960) {
  initScrollTop();
}
